import { useContext, useEffect } from 'react';
import { getText, LanguageService } from 'services/languageService';
import { Zoom } from '../../../../node_modules/ol/control';
import MapContext from '../MapContext';

const ZoomControl = () => {
  const { map } = useContext(MapContext);
  const lang = LanguageService.getLanguage();

  useEffect(() => {
    if (!map) return;

    let zoomControl = new Zoom({
      target: 'zoom',
      zoomInTipLabel: '',
      zoomOutTipLabel: '',
    });

    map.controls.push(zoomControl);
    const zoomInTl = document.querySelector('.ol-zoom-in');
    const zoomOutTl = document.querySelector('.ol-zoom-out');
    zoomInTl.setAttribute('data-tooltip', getText('ZOOM_IN_TL'));
    zoomOutTl.setAttribute('data-tooltip', getText('ZOOM_OUT_TL'));

    return () => map.controls.remove(zoomControl);
  }, [map, lang]);

  return null;
};

export default ZoomControl;
